import Vue from 'vue'

// State
const state = {
  isLoading: false,
  data: null
}

// Mutations
const fetchRolesRequest = 'fetchRolesRequest'
const fetchRolesResponse = 'fetchRolesResponse'

const mutations = {
  [fetchRolesRequest] (state) {
    state.isLoading = true
  },
  [fetchRolesResponse] (state, roles) {
    state.isLoading = false
    state.data = roles
  }
}

// Actions
export const fetchRoles = 'fetchRoles'
const actions = {
  [fetchRoles]: ({ commit }) => {
    commit(fetchRolesRequest)
    return Vue.http.get(`${SERVER_URL}/roles`).then(({ data: roles }) => {
      commit(fetchRolesResponse, roles)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js